export const TOUR_SLUGS1 = {
   "hampi-tour-package":"6758069accbc8529dc31d213",
   "hampi-half-day-package":"675c424ee2a43fc51e2385fc",
    "badami-tour-package":"6755f73cdaba6cb36cbf0aab" ,
    "hampi-virupaksha-temple":"675ca7c1f5cb804d72431bf6",
    "tungabhadra-dam-siteseeing":"6755f231daba6cb36cbf0aa1",

    // "6755f73cdaba6cb36cbf0aab"
    "bijapur-tour-package":"678962a9c68cb1bcceb70745",
  "sandur-tour-package": "67686981a7eaeba2f056e9f4",
   "atal-bihari-vajpayee-zoological-park":"6755f3a3daba6cb36cbf0aa5",
    "anjanadri-tour-package":"676925729f7d3dd16aa5cbbf",

    "Free & Easy - Rent a Car with a Driver for 1 Day":"hospete-taxi-rental",
    "Tunga Bhadra Dam Sightseeing": "tunga-bhadra-dam",
    "Virupaksha Temple & Monuments":"virupaksha-temple",
    "Hampi Zoo & Safari, Bear Sanctuary":"hampi-zoo",
    "Airport Drop Services":"jsw-airport",
    "Anjanadri, Anegundi & Kishkinda":"anjanadri-temple"
  };
  export const TOUR_SLUGS = {
    "hampi-tour-package":"6758069accbc8529dc31d213",
    "hampi-half-day-package":"675c424ee2a43fc51e2385fc",
     "badami-tour-package":"6755f73cdaba6cb36cbf0aab" ,
     "hampi-virupaksha-temple":"675ca7c1f5cb804d72431bf6",
     "tungabhadra-dam-siteseeing":"6755f231daba6cb36cbf0aa1",
 
     // "6755f73cdaba6cb36cbf0aab"
     "bijapur-tour-package":"678962a9c68cb1bcceb70745",
   "sandur-tour-package": "67686981a7eaeba2f056e9f4",
    "atal-bihari-vajpayee-zoological-park":"6755f3a3daba6cb36cbf0aa5",
     "anjanadri-tour-package":"676925729f7d3dd16aa5cbbf",
 
     "Free & Easy - Rent a Car with a Driver for 1 Day":"hospete-taxi-rental",
     "Tunga Bhadra Dam Sightseeing": "tunga-bhadra-dam",
     "Virupaksha Temple & Monuments":"virupaksha-temple",
     "Hampi Zoo & Safari, Bear Sanctuary":"hampi-zoo",
     "Airport Drop Services":"jsw-airport",
     "Anjanadri, Anegundi & Kishkinda":"anjanadri-temple"
   };
  